import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

import { Select, MenuItem, ListSubheader, TextField, InputAdornment } from '@material-ui/core';

import { multiSelectStrings } from '../../../Functions/utils';
import { update } from '../../../Functions/admin';
import { useAppContext } from '../../../Context/App/Provider';
import { useEventContext } from '../../../Context/Event/Provider';

import './PeriodSelect.css';


export default function PeriodSelect({ onChangePeriod, defaultValue = undefined }) {
  const { t } = useTranslation();

  // const loading = false;

  const [{ settings, loading }] = useAppContext(); // global context
  const [{ groupsLocationsStatus }] = useEventContext();

  const [periodsOpen, setPeriodsOpen] = useState(false);
  const [value, setValue] = useState(defaultValue ? defaultValue : (settings.period.includes(',') ? 'choose' : settings.period));

  const handleSelectPeriod = (e, period) => {
    e.preventDefault();

    setValue(period.value)
    onChangePeriod(period.value);
  }
 
  const localPeriods = [
    {
      value: '0',
      label: t('sidebar.filters.period.today')
    },
    {
      value: '24',
      label: t('sidebar.filters.period.last_24h')
    },
    {
      value: '-1',
      label: t('sidebar.filters.period.yesterday')
    },
    {
      value: '0w',
      label: t('sidebar.filters.period.current_week')
    },
    {
      value: '7',
      label: t('sidebar.filters.period.last_7d')
    },
    {
      value: '-1w',
      label: t('sidebar.filters.period.previous_week')
    },
    {
      value: '0m',
      label: t('sidebar.filters.period.current_month')
    },
    {
      value: '30',
      label: t('sidebar.filters.period.last_30d')
    },
    {
      value: '-1m',
      label: t('sidebar.filters.period.previous_month')
    },
    {
      value: '60',
      label: t('sidebar.filters.period.last_60d')
    },
    {
      value: '6m',
      label: t('sidebar.filters.period.last_6m')
    }
  ]


  let periodName = '';
  if (value) {
    for (const period of localPeriods) {
      if (period.value == value) {
        periodName = period.label;
      }
    }
  }

  const disabled = loading || (groupsLocationsStatus === "loading");

  return (
    <Select className="sidebar__select"
      style={{
        display: "flex",

        width: '100%',
        height: '34px',
        padding: '0 8px',
        maxWidth: '1000%',
        outline: '0',
        // cursor: 'pointer',
        fontSize: '15px',
        fontWeight: '600',
        fontFamily: 'inherit',

        transition: '0.25s',
        color: 'rgb(var(--accent-color))',
        borderRadius: 'var(--radius-small)',
        backgroundColor: 'var(--select-bg)',
        border: '0 px solid var(--separation-color-light)',

        opacity: (loading) ? '0.4' : '1',
        cursor: (loading) ? 'not-allowed' : 'pointer'
      }}

      disabled={disabled}

      id='group_selecter'
      variant='outlined'
      displayEmpty

      // title={groupsName}

      open={periodsOpen}

      onClose={() => {
        // console.log("130 - onClose -> setPeriodsOpen(false);");
        setPeriodsOpen(false);
      }}
      onOpen={() => {
        // console.log("134 - onOpen -> setPeriodsOpen(true);");
        setPeriodsOpen(true)
      }}

      labelWidth={0}
      value={value}
      onChange={e => {
      }}

      //<option value="choose" hidden>{t('sidebar.filters.period.select')}</option>
      renderValue={value => {
        if (value === "choose") {
          return (
            <span
              style={{
                width: "100%",
                maxWidth: "100%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))'                

              }}>{t('sidebar.filters.period.select')}
            </span>
          )
        }
        return (
          <span
            style={{
              width: "100%",
              maxWidth: "100%",
              textAlign: 'left',
              fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
              transition: '0.25s',
              color: 'rgb(var(--accent-color))',

            }}>{periodName}
          </span>
        )
      }}
    >
      <MenuItem value="choose" style={{ display: 'none' }}>{t('sidebar.filters.period.select')}</MenuItem>

      {localPeriods && localPeriods.length > 0 ? (
        localPeriods.map((period, key) => {

          return (
            <MenuItem
              value={period.id}
              name={period.label}

              style={{
                paddingLeft: '6px',
                paddingRight: '20px',
                lineHeight: '20x',
                display: 'flex'
              }}

              onClick={(e) => {
                e.stopPropagation();
                handleSelectPeriod(e, period)
              }}
            >
              <span
                style={{
                  padding: '0 4px',
                  width: "84%",
                  maxWidth: "100%",
                  textAlign: 'left',
                  fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                  transition: '0.25s'
                }}
              >{period.label}
              </span>
            </MenuItem >
          )
        }
        )

      ) : (
        <div>
        </div>
      )}
    </Select>);
}
